/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "Constants/SagaConstants";
import { getAuthToken } from "./ApiUtils";

/**
 * The base query with auth.
 * @param {Record<string, unknown>} args - The arguments for the base query.
 * @param {string} api - The api.
 * @param {Record<string, unknown>} extraOptions - The extra options.
 * @returns {Promise<unknown>} The base query with auth.
 */
const baseQueryWithAuth = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers) => {
      headers = await getAuthToken(headers);
      return headers;
    },
  });

  return baseQuery(args, api, extraOptions);
};

/**
 * The benefit management API.
 * @type {import("@reduxjs/toolkit/query/react").BaseQueryApi}
 * Get the list of benfits usinh Yaml file.
 */
export const benefitManagementApi = createApi({
  baseQuery: baseQueryWithAuth,
  reducerPath: "benefitManagementApi",
  endpoints: (builder) => ({
    getBenefits: builder.query({
      query: () => "benefitmanagement/benefits",
    }),
  }),
});

export const { useGetBenefitsQuery } = benefitManagementApi;
export const { getBenefits } = benefitManagementApi.endpoints;
export default benefitManagementApi.reducer;
